import * as React from 'react';
import './EmptyRow.css';

interface EmptyRowProps {
  /** 表の列数。行を表の幅いっぱいに広げるために使う */
  colSpan: number;
  message?: string;
}

/**
 * 表のデータが0件のときに、tbodyの中に置く1行。
 */
export const EmptyRow: React.FC<EmptyRowProps> = function (props) {
  return (
    <tr className="EmptyRow">
      <td className="EmptyRow-cell" colSpan={props.colSpan}>
        {props.message ?? 'データがありません'}
      </td>
    </tr>
  );
};
